// 监听并注册Alpine实例
document.addEventListener('alpine:init', () => {

  // 注册backdropDesignersWanted组件
  Alpine.data('backdropDesignersWanted', () => ({
    init() {

      // 表单验证
      this.setupFormValidation();
    },

    setupFormValidation() {
      const form = document.getElementById('bdw-form');
      if (!form) return;

      const fileInput = document.getElementById('bdw-images');
      const errorDiv = document.getElementById('bdw-file-error');
      const fileList = document.getElementById('bdw-file-list');
      const dragger = document.getElementById('bdw-upload-dragger');
      let selectedFiles = [];

      // 显示错误信息
      const showError = (message) => {
        if (errorDiv) {
          errorDiv.textContent = message;
          errorDiv.style.display = 'block';
        }
      };

      // 隐藏错误信息
      const hideError = () => {
        if (errorDiv) {
          errorDiv.style.display = 'none';
        }
      };

      // 格式化文件大小
      const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
      };

      // 渲染文件列表
      const renderFileList = () => {
        if (!fileList) return;

        if (selectedFiles.length === 0) {
          fileList.innerHTML = '';
          return;
        }

        fileList.innerHTML = selectedFiles.map((file, index) => {
          const fileSize = formatFileSize(file.size);
          return `
            <div class="bdw-upload__file-item">
              <svg class="bdw-upload__file-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path d="M854.6 288.6L639.4 73.4c6-6 9.4-14.1 9.4-22.6V0H176c-35.3 0-64 28.7-64 64v896c0 35.3 28.7 64 64 64h672c35.3 0 64-28.7 64-64V320.5c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v240c0 23.2 18.8 42 42 42h240v470z" fill="currentColor"/>
              </svg>
              <div class="bdw-upload__file-info">
                <div class="bdw-upload__file-name">${file.name}</div>
                <div class="bdw-upload__file-size">${fileSize}</div>
              </div>
              <button type="button" class="bdw-upload__file-remove" data-index="${index}">Remove</button>
            </div>
          `;
        }).join('');

        // 绑定删除按钮事件
        fileList.querySelectorAll('.bdw-upload__file-remove').forEach(btn => {
          btn.addEventListener('click', (e) => {
            const index = parseInt(e.target.getAttribute('data-index'));
            selectedFiles.splice(index, 1);
            updateFileInput();
            renderFileList();
            validateFiles();
          });
        });
      };

      // 更新文件输入
      const updateFileInput = () => {
        if (!fileInput) return;

        const dataTransfer = new DataTransfer();
        selectedFiles.forEach(file => {
          dataTransfer.items.add(file);
        });
        fileInput.files = dataTransfer.files;
      };

      // 单文件 5MB，总大小 20MB（与 demo.html 一致）
      const MAX_SINGLE_SIZE = 5 * 1024 * 1024;  // 5MB
      const MAX_TOTAL_SIZE = 20 * 1024 * 1024;  // 20MB

      // 处理文件选择
      const handleFiles = (files) => {
        const fileArray = Array.from(files);
        const maxFiles = 5;

        // 检查文件数量
        if (selectedFiles.length + fileArray.length > maxFiles) {
          showError(`Maximum ${maxFiles} files allowed, please remove some files first`);
          return;
        }

        let currentTotal = selectedFiles.reduce((sum, f) => sum + f.size, 0);

        for (let file of fileArray) {
          if (file.size > MAX_SINGLE_SIZE) {
            showError(`File "${file.name}" exceeds the 5MB limit.`);
            return;
          }
          if (currentTotal + file.size > MAX_TOTAL_SIZE) {
            showError(`Total size of all files would exceed the 20MB limit.`);
            return;
          }
          currentTotal += file.size;
          selectedFiles.push(file);
        }

        updateFileInput();
        renderFileList();
        validateFiles();
      };

      // 验证文件的方法
      const validateFiles = () => {
        if (!fileInput) return true;

        // 检查是否使用了高级文件上传器（FilePond）
        const filePondInstance = fileInput.filepond;

        if (filePondInstance) {
          // 使用高级文件上传器
          const files = filePondInstance.getFiles();
          const fileCount = files.length;

          if (fileCount === 0) {
            showError('Please upload at least 1 image');
            return false;
          }

          if (fileCount > 5) {
            showError('Maximum 5 images allowed, please remove extra images');
            return false;
          }

          // 检查单文件 5MB、总大小 20MB
          let totalSize = 0;
          for (let file of files) {
            if (file.fileSize > MAX_SINGLE_SIZE) {
              showError(`File "${file.filename}" exceeds the 5MB limit.`);
              return false;
            }
            totalSize += file.fileSize;
          }
          if (totalSize > MAX_TOTAL_SIZE) {
            showError(`Total size of all files (${(totalSize / 1024 / 1024).toFixed(2)}MB) exceeds the 20MB limit.`);
            return false;
          }

          hideError();
          return true;
        } else {
          // 使用新的文件列表验证
          const fileCount = selectedFiles.length;

          if (fileCount === 0) {
            showError('Please upload at least 1 image');
            return false;
          }

          if (fileCount > 5) {
            showError('Maximum 5 images allowed, please remove extra images');
            return false;
          }

          // 检查单文件 5MB、总大小 20MB
          let totalSize = 0;
          for (let file of selectedFiles) {
            if (file.size > MAX_SINGLE_SIZE) {
              showError(`File "${file.name}" exceeds the 5MB limit.`);
              return false;
            }
            totalSize += file.size;
          }
          if (totalSize > MAX_TOTAL_SIZE) {
            showError(`Total size of all files (${(totalSize / 1024 / 1024).toFixed(2)}MB) exceeds the 20MB limit.`);
            return false;
          }

          hideError();
          return true;
        }
      };

      // 文件输入变化事件
      if (fileInput) {
        fileInput.addEventListener('change', (e) => {
          if (e.target.files && e.target.files.length > 0) {
            handleFiles(e.target.files);
          }
        });
      }

      // 拖拽上传功能
      if (dragger) {
        // 兜底：点击拖拽区域时，打开文件选择框
        dragger.addEventListener('click', (e) => {
          // 如果已经点在 input 上，就不重复触发
          if (e.target === fileInput) return;
          if (fileInput) fileInput.click();
        });

        // 阻止默认拖拽行为
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
          dragger.addEventListener(eventName, (e) => {
            e.preventDefault();
            e.stopPropagation();
          });
        });

        // 拖拽进入
        dragger.addEventListener('dragenter', () => {
          dragger.classList.add('is-dragover');
        });

        // 拖拽离开
        dragger.addEventListener('dragleave', (e) => {
          // 只有当离开整个拖拽区域时才移除样式
          if (!dragger.contains(e.relatedTarget)) {
            dragger.classList.remove('is-dragover');
          }
        });

        // 拖拽放下
        dragger.addEventListener('drop', (e) => {
          dragger.classList.remove('is-dragover');
          const files = e.dataTransfer.files;
          if (files && files.length > 0) {
            handleFiles(files);
          }
        });
      }

      // 表单提交：不跳转，用 fetch 提交；提交后隐藏表单，仅显示接口返回信息
      const formBody = document.getElementById('bdw-form-body');
      const resultDiv = document.getElementById('bdw-form-result');
      const submitBtn = document.getElementById('bdw-form-submit');
      const formAction = form.action;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!validateFiles()) return;

        if (resultDiv) {
          resultDiv.style.display = 'none';
          resultDiv.textContent = '';
          resultDiv.className = 'bdw-form__result';
        }
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending...';
        }

        try {
          const formData = new FormData(form);
          const res = await fetch(formAction, {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          const data = await res.json().catch(() => ({}));

          if (formBody) formBody.style.display = 'none';
          if (resultDiv) {
            resultDiv.style.display = 'block';
            if (res.ok && data.success) {
              resultDiv.classList.add('success');
              resultDiv.textContent = data.message || 'Email sent successfully!';
              form.reset();
              selectedFiles = [];
              updateFileInput();
              renderFileList();
            } else {
              resultDiv.classList.add('error');
              resultDiv.textContent = data.message || data.error || 'Send failed. Please try again later.';
            }
          }
        } catch (err) {
          if (formBody) formBody.style.display = 'none';
          if (resultDiv) {
            resultDiv.style.display = 'block';
            resultDiv.classList.add('error');
            resultDiv.textContent = 'Network error. Please check your connection and try again.';
          }
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit';
          }
          // 提交结束后延迟 200ms 将表单滚动到视口居中，便于查看结果
          setTimeout(() => {
            const formEl = document.getElementById('bdw-form');
            if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 200);
        }
      });
    }
  }));
});
